import { useCallback, useState } from 'react';

import InterviewPracticeQuestionSelectLastModal from './lastModal';
import InterviewPracticeQuestionSelectBodyFrequency from './contents/frequency';
import InterviewPracticeQuestionSelectBodyMyself from './contents/myself';
import { QuestionType } from '@domain/constant/questionType';
import Header from '@common/header';
import Layout from '@common/layout';
import Content from '@common/content';
import Footer from '@common/footer';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';
import InterviewPracticeQuestionSelectHeader from '../common/header/header';
import InterviewPracticeQuestionSelectBody from '../common/body/body';
import InterviewPracticeQuestionSelectBodyCompany from './contents/company';
import InterviewPracticeQuestionSelectBodySelected from './contents/selected';
import InterviewPracticeQuestionSelectBodyAcc from './contents/acc';

const InterviewPracticeQuestionSelect = () => {
  const { selectedQuestionList, activeTab } = useInterview();
  const [lastModalVisible, setLastModalVisible] = useState(false);

  const isSelectedQuestion = selectedQuestionList.length > 0;

  const openLastModal = useCallback(() => {
    if (!isSelectedQuestion) {
      return;
    }
    setLastModalVisible(true);
  }, [isSelectedQuestion]);

  const closeLastModal = useCallback(() => {
    setLastModalVisible(false);
  }, []);

  const renderBody = () => {
    switch (activeTab) {
      case QuestionType.COMPANY:
        return <InterviewPracticeQuestionSelectBodyCompany />;
      case QuestionType.FREQUENCY:
        return <InterviewPracticeQuestionSelectBodyFrequency />;
      case QuestionType.ACC:
        return <InterviewPracticeQuestionSelectBodyAcc />;
      case QuestionType.MYSELF:
        return <InterviewPracticeQuestionSelectBodyMyself />;
      case QuestionType.SELECTED:
        return <InterviewPracticeQuestionSelectBodySelected />;
    }
  };

  return (
    <Layout>
      <Header />
      <Content>
        <InterviewPracticeQuestionSelectHeader />
        <InterviewPracticeQuestionSelectBody onClickNext={openLastModal}>
          {renderBody()}
        </InterviewPracticeQuestionSelectBody>
        <InterviewPracticeQuestionSelectLastModal visible={lastModalVisible} onCloseClick={closeLastModal} />
      </Content>
      <Footer />
    </Layout>
  );
};

export default InterviewPracticeQuestionSelect;
